import { useMemo } from "react";
import useRecorderContext from "../context/useRecorderContext";

/**
 * Hook to detect if webcam or screen streams are active.
 * 
 * SIMPLIFIED LOGIC: We now simply check if actual MediaStreams are active.
 * Canvas object detection was removed because leftover canvas objects
 * (like placeholders) were incorrectly blocking the NoStreamLayer in scene mode.
 */
export const useCanvasStreamDetection = () => {
  const { webcamStream, screenStream } = useRecorderContext();

  // Simply check if actual MediaStreams are active
  const hasCanvasWebcam = useMemo(() => !!webcamStream, [webcamStream]);
  const hasCanvasScreen = useMemo(() => !!screenStream, [screenStream]);
  const hasAnyCanvasStream = hasCanvasWebcam || hasCanvasScreen;

  return {
    hasCanvasWebcam,
    hasCanvasScreen,
    hasAnyCanvasStream
  };
};
